











import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  name: 'ForgotPasswordConfirm'
})
export default class ForgotPasswordConfirm extends Vue {
  @Prop({ default: '' })
  public email;
}
